/* eslint-disable no-restricted-globals */
import { Button, Carousel, Modal, notification, Radio } from "antd";
import cloneDeep from "lodash/cloneDeep";
import React, { useCallback, useEffect, useState } from "react";
import { GoCheck } from "react-icons/go";
import { connect } from "react-redux";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import bookStoreImgLarge from "../../assets/img/book-mockup-store-xl.png";
import bookStoreImg from "../../assets/img/book-mockup-store.png";
import bookIllustration from "../../assets/img/book_line.png";
import giftCardImg from "../../assets/img/gift-card/cards.png";
import giftCardMobileImg from "../../assets/img/gift-card/cards-mobile.png";
import beesIllustration from "../../assets/img/illustrations/bees-illustration.png";
import beesIllustration2 from "../../assets/img/illustrations/bees-illustration-2.png";
import cameraIllustration from "../../assets/img/illustrations/camera-illustration.png";
import fireworksIllustration from "../../assets/img/illustrations/fireworks-illustration.png";
import safetypinsIllustration from "../../assets/img/illustrations/safetypins-illustration.png";
import threeStarsIllustration from "../../assets/img/illustrations/three-stars-illustration.png";
import { PAGE_URL } from "../../env";
import { useWindowSize } from "../../hooks/WindowsSize";
import { StripeProduct } from "../../interfaces";
import { CartItem } from "../../interfaces/cart";
import { Product } from "../../interfaces/product";
import { User } from "../../interfaces/user";
import { AppState, sagaMiddleware } from "../../store";
import { addProductStore } from "../../store/sagas/cart";
import { sendWelcomeEmail } from "../../store/sagas/user";
import { trackAction } from "../../utils/marketing";
import "./Store.scss";

declare global {
  interface Window {
    fpr: any;
  }
}


const plansInfoDesktop = [
  {
    title: "Ad-free experience",
    perk1: true,
    perk2: true,
    bold: false,
  },
  {
    title: "Create & order books",
    perk1: true,
    perk2: true,
    bold: false,
  },
  {
    title: "Question prompts & auto-generated content",
    perk1: true,
    perk2: true,
    bold: false,
  },
  {
    title: "Complete past milestones at any time",
    perk1: true,
    perk2: true,
    bold: false,
  },
  {
    title: "Import photos from various sources",
    perk1: true,
    perk2: true,
    bold: false,
  },
  {
    title: "Growth charts",
    perk1: true,
    perk2: true,
    bold: false,
  },
  {
    title: "10% off all book orders",
    perk1: false,
    perk2: true,
    bold: true,
  },
  {
    title: "Free shipping",
    perk1: false,
    perk2: true,
    bold: true,
  },
  {
    title: "Friends & family guest access",
    perk1: false,
    perk2: true,
    bold: false,
  },
  {
    title: "Photo only page layout options",
    perk1: false,
    perk2: true,
    bold: false,
  },
  {
    title: "Access full library of book covers",
    perk1: false,
    perk2: true,
    bold: false,
  },
  {
    title: "Exclusive font options",
    perk1: false,
    perk2: true,
    bold: false,
  },
  {
    title: "High resolution downloads",
    perk1: false,
    perk2: true,
    bold: false,
  },
  {
    title: "Multiple child profiles",
    perk1: false,
    perk2: true,
    bold: false,
  },
  {
    title: "Premium illustrations and design features",
    perk1: false,
    perk2: true,
    bold: false,
  },
  {
    title: "Collage options for multiple photos",
    perk1: false,
    perk2: true,
    bold:false,
  },
  {
    title: "Multiple choice question prompts",
    perk1: false,
    perk2: true,
    bold:false,
  },
  {
    title: "Auto-generated story content",
    perk1: false,
    perk2: true,
    bold:false,
  },
  {
    title: "Unlimited secure storage",
    perk1: false,
    perk2: true,
    bold:false,
  },
];

const carouselInfo = [
  {
    img: beesIllustration,
    title: "PLUS membership includes",
    info: "Premium illustrations and decorative content",
  },
  {
    img: threeStarsIllustration,
    title: "PLUS membership includes",
    info: "Multiple profiles to document each child in your family",
  },
  {
    img: bookIllustration,
    title: "PLUS membership includes",
    info: "Access to additional book cover options",
  },
  {
    img: fireworksIllustration,
    title: "membership includes",
    info: "PLUS subscriptions get 10% off orders and free shipping",
  },
  {
    img: safetypinsIllustration,
    title: "PLUS membership includes",
    info: "Unlimited storage, save as many babypages as you like",
  },
  {
    img: cameraIllustration,
    title: "PLUS membership includes",
    info: "High-resolution downloads without watermarks",
  },
];

interface Props {
  showFree?: boolean;
  isPlus?: boolean;
  stripeProducts: StripeProduct[];
  store?: string;
  user: User;
  products: Product[];
}

const Store: React.FC<Props> = ({
  showFree,
  isPlus,
  stripeProducts,
  store,
  user,
  products,
}) => {
  const [width] = useWindowSize();
  const history = useHistory();
  const location = useLocation();


  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);

  const addGiftCard = () => {
    history.push("/giftcards");
  };

  const sendEmail = useCallback(() => {
    sagaMiddleware.run<any>(sendWelcomeEmail, (error?: string) => {
      if (!!error) {
        Modal.error({
          title: "Error",
          content: error,
        });
      }
    });
  }, []);

  const [continuePath, setContinuePath] = useState("");
  const [checkboxActive, setCheckboxActive] = useState("");
  const [desktopDevice, setDesktopDevice] = useState(true);
  const [product, setProduct] = useState<Product | undefined>(undefined);

  const subscriptionOptions = products.filter(item => item.type === "subscription" && !!item.stripe_id && item.description !== 'six month')
                                      .map(item => {
                                            return {
                                              ...item,
                                              id: item.stripe_id,
                                              qty: 1,
                                              price: (item.price / 100),
                                              selected: false,
                                              sku_id: null,
                                              sku_type: null,
                                              sku_image: null,
                                              sku_attributes: null,
                                              sku_package_dimensions: null,
                                              sku_inventory: null,
                                              shippable: false,
                                              attributes: null,
                                              package_dimensions: null,
                                              active: null,
                                              metadata: [],
                                              images: null,                                                                                  
                                            }
                                          }) 

  const planClickHandler = (
    planType: string,
    isDesktopDevice: boolean = false
  ) => {
    const query = queryString.parse(location.search);
    let hookInfo = `/cart/subscription/${planType}`;

    if (planType === "free") {
      hookInfo = "/";

      if (!!isDesktopDevice) {
        if (location.pathname === "/step-3") {
          if (query.fpr) {
            window.fpr("referral", {
              email: user.email,
              uid: user.stripe_id,
            });
          }
          sendEmail();
        }

        history.push("/");
      }

      if(location.pathname === "/step-3") {
        trackAction(
          "KeepFreeSubscriptionAfterCreateNewUser",
          {
            facebook: {
              action: "Keep free subscription",
            },
            amplitude: {
              action: "Keep free subscription",
            },
            pinterest: {
              action: "Keep free subscription",
            },
            google: {
              event:
                "kept_free_sub_after_signup",
            },
          },
          true
        );
      }
    } else {
      trackAction("SelectSubscription", {
        google: {
          event: "select_subscription"
        }
      }, 
      true
      )
    }

    setContinuePath(hookInfo);
    setCheckboxActive(planType);

    // Going to CheckoutPage directly
    setProduct(products.find((p) => p.description === planType));
    setDesktopDevice(isDesktopDevice);
  };

  // Going to CheckoutPage directly
  const onCheckout = useCallback(() => {
    if (!!product) {
      sagaMiddleware.run<any>(
        addProductStore,
        {
          book_id: null,
          babypage_id: null,
          event: "",
          gift: {
            status: false,
            email: "",
            receiver: "",
            message: "",
            date: "",
          },
          id: product.stripe_id,
          item: product.description,
          description: product.description,
          options: subscriptionOptions.map((e) => {
            if (e.description === product.description) return { ...e, selected: true };
            return e;
          }),
          prices: { monthly: 7.99, "three month": 13.98, "one year": 45 },
          qty: 1,
          stripe_id: product.stripe_id,
          subtitle: `BabyPage ${product.title}`,
          thumbnail: "",
          title: "BabyPage PLUS Subscription",
          total: product.price / 100,
          type: product.type,
        },
        (error?: string, _?: string) => {
          if (!!error) {
            Modal.error({
              title: "Error",
              content: error,
            });
          } else {
            history.push("/checkout");
          }
        }
      );
    }
  }, [history, product]);

  useEffect(() => {
    if (!!desktopDevice && !!product) {
      onCheckout();
    }
  }, [product, desktopDevice, onCheckout]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [plansStore, setPlansStore] = useState<CartItem[]>([]);

  useEffect(() => {
    if (!!user.store) {
      try {
        const localStore = JSON.parse(user.store);
        if (!!localStore && Array.isArray(localStore)) {
          const newStore: CartItem[] =
            !!user.user_level && user.user_level === 1
              ? cloneDeep(
                  localStore.filter((e: CartItem) => e.type !== "subscription")
                )
              : cloneDeep(localStore);

          setPlansStore(
            newStore.map((e) => ({
              ...e,
              qty:
                !!e.qty && typeof e.qty === "number" && !isNaN(e.qty)
                  ? e.qty
                  : 1,
            }))
          );
        }
      } catch (error) {}
    }
  }, [user]);

  return (
    <div className={!!showFree ? `store-wrapper margin-bottom-navigation-medium` : `store-wrapper margin-bottom-navigation-small`}>
      {/* Mobile + Free Only */}
      {!isPlus && (
        <div className="col-12 d-block d-md-none">
          <div className="container styled-container pb-0">
            <div className="row">
              <div className="col-12 text-center px-0 pb-3 pb-md-5 mt-md-5 top-titles">
                <h2 className="mt-5">Select a Subscription</h2>
                <div className="col-12 col-md-8 offset-md-2">
                  <h1>
                    Start capturing all of the sweet moments, so you never
                    forget the unique details of your child's story!
                  </h1>
                </div>
                <p>Compare & select your subscription:</p>
              </div>
              <div className="col-12 text-center little-banner mt-5">
                <p className="my-2">Free 7-Day Trial!</p>
              </div>

              <div className="col-4 col-md-3 pb-md-5 px-0 plans-parent">
                <div
                  className="col-12 plans-container px-0"
                  onClick={() => planClickHandler("one year")}
                >
                  <div
                    className={`plan plan-year p-3 text-center${
                      checkboxActive === "one year" ? " active" : ""
                    }`}
                  >
                    <p>
                      <Radio
                        checked={checkboxActive === "one year"}
                        value="one year"
                        className="d-none d-lg-inline"
                      />
                      <strong>
                        Annual PLUS
                      </strong>
                    </p>
                    <p className="pl-lg-4">
                      $3.75/mo*
                    </p>
                    <p className="pl-lg-4">
                      <span className="detail">Save 53%</span>
                      
                      <span className="d-block"></span>
                    </p>
                    <p className="select-plan-mobile">Select</p>
                  </div>
                </div>
              </div>


              <div className="col-4 col-md-3 pb-md-5 px-0 plans-parent">
                <div
                  className="col-12 plans-container d-xs-block d-md-none px-0"
                  onClick={() => planClickHandler("three month")}
                >
                  <div
                    className={`plan plans-quarterly p-3 text-center${
                      checkboxActive === "three month" ? " active" : ""
                    }`}
                  >
                    <p>
                      <Radio
                        checked={checkboxActive === "three month"}
                        value="three month"
                        className="d-none d-lg-inline"
                      />
                      <strong>
                        Quarterly PLUS
                      </strong>
                    </p>
                    <p className="pl-lg-4">
                      $4.66/mo*
                      <br />
                      <span className="detail">Save 42%</span>
                    </p>
                    <p className="select-plan-mobile">Select</p>
                  </div>
                </div>
              </div>

              <div className="col-4 col-md-3 pb-md-5 px-0 plans-parent">
                <div
                  className="col-12 plans-container d-xs-block d-md-none px-0"
                  onClick={() => planClickHandler("monthly")}
                >
                  <div
                    className={`plan plans-monthly p-3 text-center${
                      checkboxActive === "monthly" ? " active" : ""
                    }`}
                  >
                    <p>
                      <Radio
                        checked={checkboxActive === "monthly"}
                        value="monthly"
                        className="d-none d-lg-inline"
                      />
                      <strong>
                        Monthly PLUS
                      </strong>
                    </p>
                    
                    <p className="text-lowercase pl-lg-4">$7.99</p>
                    <p className="select-plan-mobile">Select</p>
                  </div>
                </div>
              </div>
              <div className="col-12 plans-parent p-0">
                <div
                    className="col-12 plans-container px-0 mb-4"
                    onClick={() => planClickHandler("free")}
                  >
                    <div
                      className={`plan plan-free${
                        checkboxActive === "free" ? " active" : ""
                      }`}
                    >
                      <p className="text-center my-2">
                        <Radio
                          checked={checkboxActive === "free"}
                          value="free"
                          className="d-none d-lg-inline"
                        />
                        <strong> Free </strong> Limited Features
                      </p>
                      <p className="select-plan-mobile text-center">Select</p>
                    </div>
                  </div>
                </div>
            </div>

            {!!continuePath && (
              <Button
                type="primary"
                className="ant-btn-round btn-continue"
                onClick={() => {
                  if (continuePath === "/") {
                    if (location.pathname === "/step-3") {
                      sendEmail();
                    }

                    history.push(continuePath);
                  } else {
                    onCheckout();
                  }
                }}
              >
                Continue
              </Button>
            )}
          </div>
        </div>
      )}

      {/* Desktop + Free Only */}
      {!isPlus && (
        <>
          <div className="col-12 d-none d-md-block">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center px-0 pb-3 pb-md-5 mt-md-5 top-titles">
                  <h2>Select a Subscription</h2>
                  <div className="col-12 col-md-8 offset-md-2">
                    <h1>
                      Start capturing all of the sweet moments, so you never
                      forget the unique details of your child's story!
                    </h1>
                  </div>
                  <p>Compare & select your subscription:</p>
                </div>
              </div>

              <div className="row">
                <div className="col-12 plans-parent-desktop mb-3">
                  <div className="row">
                    <div className="col-6 right-border">&nbsp;</div>
                    <div className="col-6 text-center little-banner">
                      <p>Free 7-Day Trial!</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4 plan right-border">&nbsp;</div>
                    <div className="col-2 plan px-2 px-lg-4 no-border text-center"
                    >
                   
                      <p className="plan-bold">
                        Free
                      </p>
                      <p className="">Limited Features</p>
                      <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("free", true)}>
                        Select
                      </Button>
                    </div>

                    <div className="col-2 plan plan-anual px-2 px-lg-4 pb-4 text-center ">
                      <p className="plan-bold">
                          Annual PLUS
                      </p>
                      <p className="plan-bold">
                       $3.75/mo*
                      </p>
                      <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("one year", true)}>
                        Select
                      </Button>
                      <p className="plan-light">
                        <span className="detail">Save 53%</span>
                      </p>
                    </div>

                    <div className="col-2 plan plan-quarterly px-2 px-lg-4 pb-4 text-center">
                    
                      <p className="plan-bold">
                          Quarterly PLUS

                      </p>
                      <p className="plan-bold">
                        $4.66/mo*
                      </p>
                      <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("three month", true)} >
                        Select
                      </Button>
                      <p className="plan-light">
                        <span className="detail">Save 42%</span>
                      </p>
                    </div>

                    <div className="col-2 plan plan-monthly px-2 px-lg-4 pb-4 text-center">
                      <p className="plan-bold">
                          Monthly PLUS            
                      </p>
                      <p className="plan-bold">
                        $7.99
                      </p>
                      <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("monthly", true)}>
                        Select
                      </Button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4 plan no-border">
                      <p className="plan-light">Page limits & secure storage</p>
                    </div>
                    <div className="col-2 plan text-center no-border">
                      <p className="plan-light">15 babypages</p>
                    </div>
                    <div className="col-6 plan text-center">
                      <p className="plan-light">Unlimited</p>
                    </div>
                  </div>

                  {plansInfoDesktop.map((item, index) => {
                    return (
                      <div className="row" key={index}>
                        <div className={`col-4 plan no-border`}>
                          <p className={item.bold ? "plan-bold" : "plan-light"}>{item.title}</p>
                        </div>
                        <div className="col-2 plan text-center no-border">
                          <p>
                            {!!item.perk1 ? (
                              <GoCheck
                                size={"1.1rem"}
                                style={{ color: "#658071" }}
                              />
                            ) : null}
                          </p>
                        </div>
                        <div className="col-6 plan text-center">
                          <p>
                            {!!item.perk2 ? (
                              <GoCheck
                                size={"1.1rem"}
                                style={{ color: "#658071" }}
                              />
                            ) : null}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                  <div className="row bottom-select-plan">
                    <div className="col-4 no-border">
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-center text-center no-border">
                    <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("free", true)}>
                        Select
                      </Button>
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-center select-yearly text-center">
                      <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("one year", true)}>
                        Select
                      </Button>
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-center select-quarterly text-center">
                      <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("three month", true)}>
                        Select
                      </Button>
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-center select-monthly text-center">
                      <Button type='primary' ghost shape='round' className='px-3 py-0 select-plan-button' onClick={() => planClickHandler("monthly", true)}>
                          Select
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
             {width >= 768 ? (
               <div className="container mt-0 mb-3">
               <p className="plans-links text-center">
                 <a
                   href={`${PAGE_URL}terms`}
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   Terms of Services
                 </a>
                 &nbsp;and&nbsp;
                 <a
                   href={`${PAGE_URL}privacy`}
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   Privacy Policy
                 </a>
               </p>
               <p className="text-center mb-0">
                 *Total amounts ($13.98 for quarterly and $45 for annual
                 membership) are charged at the end of the 7-day free trial period.
               </p>
               
               <div className="text-center">
               <a onClick={() => planClickHandler("free", true)}>Continue with Free Features</a>
               </div>
              <ul className="perks px-2 mb-0 pb-3 mt-3 mb-2">
                <h3 className="text-center">Subscription Conditions</h3>
                <li className="">
                  <p className="text-center">
                    Recurring billing. Cancel anytime. Your subscription will
                    automatically renew for the same package length and same price
                    until you cancel. To cancel, go to your account profile to
                    manage your membership.
                  </p>

                  <p className="text-center mt-4">
                  <strong>7-Day Free Trial:</strong> Users within the 7-day free trial period are not entitled to the 10% off discount or free shipping benefits.
                  </p>
                </li>
              </ul>
             </div>
             ) : null }
        </>
      )}

      {/* Mobile + Free Only */}
      {!isPlus && (
        <>
        <div className="row d-xs-block d-md-none">
          <div className="col-12 py-3 mt-3">        

            <ul className="perks pl-3">
              <h3>PLUS Plans:</h3>
              <li className="pl-2 plan-bold">10% off all book orders</li>
              <li className="pl-2 plan-bold">Free shipping</li>
              <li className="pl-2">
                Friends & family guest access
              </li>
              <li className="pl-2">Photo only page layout options</li>
              <li className="pl-2">
                Access full library of book covers
              </li>
              <li className="pl-2">Exclusive font options</li> 
              <li className="pl-2">High resolution downloads</li>
              <li className="pl-2">
                Multiple child profiles
              </li>
              <li className="pl-2">
                Premium illustrations and design features
              </li>
              <li className="pl-2">Collage options for multiple photos</li>
              <li className="pl-2">Multiple choice question prompts</li>
              <li className="pl-2">Auto-generated story content</li>
              <li className="pl-2">Unlimited secure storage</li> 
            </ul>
            <ul className="perks pl-3">
              <h3>All Plans:</h3>
              <li className="pl-2">Ad-free experience</li>
              <li className="pl-2">
                Create and order books filled with babypages
              </li>
              <li className="pl-2">
                Question prompts and auto-generated content
              </li>
              <li className="pl-2">Complete past milestones at any time</li>
              <li className="pl-2">Import photos from various sources</li>
              <li className="pl-2">Track growth with charts</li>
            </ul>
          { width < 768 ? (
            <div className="container mt-0 mb-3 mb-md-5">
              <p className="plans-links text-center">
                <a
                  href={`${PAGE_URL}terms`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Services
                </a>
                &nbsp;and&nbsp;
                <a
                  href={`${PAGE_URL}privacy`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </p>
              <p className="text-center">
                *Total amounts ($13.98 for quarterly and $45 for annual
                membership) are charged at the end of the 7-day free trial period.
              </p>
            
              <div className="text-center">
              <a onClick={() => planClickHandler("free", true)}>Continue with Free Features</a>
              </div>
            </div>
        ) : null }

            <ul className="perks px-2 mb-0 pb-3">
              <h3 className="text-center">Subscription Conditions</h3>

              <li className="">
                <p className="text-center">
                  Recurring billing. Cancel anytime. Your subscription will
                  automatically renew for the same package length and same price
                  until you cancel. To cancel, go to your account profile to
                  manage your membership.
                </p>

                <p className="text-center mt-4">
                  <strong>7-Day Free Trial:</strong> Users within the 7-day free trial period are not entitled to the 10% off discount or free shipping benefits.
                  </p>
              </li>
            </ul>
          </div>
        </div> 
        </>
      )}
      {/* Always Visible */}
      <div className="BooksBox">
        <div className="container-xl px-0">
          <div className="row">
            <div className="col-md-6 col-xl-6 px-0">
              {width > 1199 && (
                <div className="col-12 px-0">
                  <img src={bookStoreImgLarge} className="xl-img" alt="BP Books" />
                </div>
              )}
              {width > 767 && width < 1200 && (
                <div className="h-100 d-flex align-items-center">
                  <img src={bookStoreImg} alt="BP Books" />
                </div>
              )}
              
            </div>

            <div className="col-md-6 col-12">
              <div className="col-md-9 col-xl-10 col-10 mx-auto">
                <h1 className="mb-4 mt-md-5">
                  <strong>
                    Assemble your babypages into beautiful, high-quality books
                  </strong>
                </h1>
                <p className="mb-5">
                  You don't need to wait to create a full year of memories with
                  BabyPage. Simply customize your pages, select your cover, and
                  print! Starting at only $23, build a book for every season to
                  capture your child's story.
                </p>

                {width > 767 && (
                  <button
                    onClick={() => history.push("/books")}
                    className="btn plan-btn"
                  >
                    Learn More
                  </button>
                  
                )}
              </div>
              
              {width < 768 && (
                <>
                  <div className="row">
                    <div className="col-12 col-lg-6 text-center">
                      <button
                        onClick={() => history.push("/books")}
                        className="btn plan-btn"
                      >
                        Learn More
                      </button>
                    </div>
                  </div>

                  <div className="img-container text-center container">
                    <img className="w-100" src={bookStoreImgLarge} alt="BP Books" />
                  </div>
                </>
              )}
            </div>
            <div className="col-3 mx-auto d-none d-md-block">
              <div className="img-container text-center container">
                <img className="w-100" src={beesIllustration2} alt="BP Bee" />
              </div>
            </div>
            <div className="col-12 py-5">
              <div className="col-md-8 mx-auto ">
                <h1 className="text-center mt-5 mb-4">
                  <strong>BabyPage Gift Card</strong>
                </h1>
                  <p className="text-center">
                    A BabyPage gift card is a great way to send a unique and
                    meaningful gift to any parent! You can purchase any amount in
                    increments of $10, and the gift card will be sent straight to
                    their inbox. The recipient can purchase a Plus membership
                    and/or print memory books to cherish forever.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 GiftCardBox">
        <div className="container">
          
          {width > 767 && (
            <div className="mx-auto">
              <img src={giftCardImg} alt="BP Gift Card" />
            </div>
          )}
          {width < 768 && (
            <div className="mx-auto">
              <img src={giftCardMobileImg} alt="BP Gift Card" />
            </div>
          )}
          <div className="col-12 text-center mt-5">
            <button onClick={addGiftCard} className="btn plan-btn btn-lg">
              Purchase Gift Card
            </button>
          </div>
        </div>
      </div>

      <div className="footer mx-auto d-table my-3">
        <a href={`${PAGE_URL}terms`} target="_blank" rel="noopener noreferrer">
          Terms of Service
        </a>
        <span className="mx-3">|</span>
        <a
          href={`${PAGE_URL}privacy`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  stripeProducts: state.stripeProduct,
  store: state.user.store,
  user: state.user,
  products: state.product.products,
});

export default connect(mapStateToProps)(Store);
